import { cn } from "../lib/utils";

type Props = React.HTMLAttributes<HTMLDivElement> & {
  title: string;
};

export function AccessSeparator({ title, className, ...props }: Props) {
  return (
    <div className={cn("relative", className)} {...props}>
      <div className="absolute inset-0 flex items-center">
        <span className="w-full border-t"></span>
      </div>
      <div className="relative flex justify-center text-xs uppercase">
        <span className="bg-background px-2 text-muted-foreground">
          {title}
        </span>
      </div>
    </div>
  );
}
